<template src="./TextMessage.html"></template>

<script>
export default {
  data() {
    return {
      dataBody: "",
      dataToMessage: [],
    };
  },
  methods: {
    sendData() {
      this.$store.dispatch("setCargando", true);
      try {
        if (confirm("¡Está seguro de enviar este mensaje!")) {
          this.dataToMessage = {
            template: "no_aplica",
            type: "text",
            body: this.dataBody,
          };
          this.$emit("dataToSend", this.dataToMessage);
        } else {
          this.$store.dispatch("setCargando", false);
        }
      } catch (error) {
        console.log(error);
      }
    },
    cancel() {
      this.$emit("cancel");
    },
  },
};
</script>

<style src="./TextMessage.scss" lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/MensajesMasivos/TextMessage/TextMessage.vue